export default __webpack_public_path__ + "static/media/Programação (Real Size).0f50a7e5.svg";